import Vue from 'vue'
import Vuex from 'vuex'
import {
  login as loginApi,
  fetchAuthToken as fetchAuthTokenApi,

  validateXML as validateXMLApi
} from '../client'
Vue.use(Vuex)


export default new Vuex.Store({
  strict: true,
  state: {
    user: {
      userData: null,
      userAddresses: [],
      authToken: null,
      userContracts: []
    },
    suppliers: [],
    letters: [],
  },
  mutations: {
    SET_USER_DATA(state, data) {
      state.user.userData = data
      localStorage.setItem("user", JSON.stringify(state.user))
    },
    SET_USER_ADDRESSES(state, data) {
      state.user.userAddresses = data
      localStorage.setItem("user", JSON.stringify(state.user))
    },
    SET_USER_CONTRACTS(state, data) {
      state.user.userContracts = data
      localStorage.setItem("user", JSON.stringify(state.user))
    },
    SET_AUTH_TOKEN(state, data) {
      state.user.authToken = data
      localStorage.setItem("user", JSON.stringify(state.user))
    },
    DELETE_SESSION(state, data) {
      state.user.authToken = null
      state.user.userAddresses = []
      state.user.userData = null
      localStorage.removeItem("user")
    },
    SET_LOCALE(state, data) {
      state.i18n.locale = data
    }
  },
  actions: {
     login({ commit }, params) {
       return new Promise(async (resolve, reject) => {
        try {
          let response = await loginApi(params)
          let userData = {}
          let userAddress = []
          if (Array.isArray(response)) {
            let user = response.shift()
            userData = user.Value.reduce((acc, curr) => {
              acc[curr["@type"]] = curr["$"]
              return acc
            }, {})
            userAddress = response.map(i => {
              return i.Value.reduce((acc, curr) => {
                acc[curr["@type"]] = curr["$"] || ""
                return acc
              }, {})
            })
            commit('SET_USER_DATA', userData)
            commit('SET_USER_ADDRESSES', userAddress)
            const { TransferID, TransferKey } = userData
            let tokenRes = await this.dispatch('fetchAuthToken', { TransferID, TransferKey })
            resolve(tokenRes)
            // commit('SET_AUTH_TOKEN')
          } else {
/*             Vue.notify({
              type: "warn",
              text: Vue.i18n.translate("letters.userAddressMissing"),
              duration: 10000
            }) */
            let user = response
            userData = user.Value.reduce((acc, curr) => {
              acc[curr["@type"]] = curr["$"]
              return acc
            }, {})

            commit('SET_USER_DATA', userData)
            const { TransferID, TransferKey } = userData
            let tokenRes = await this.dispatch('fetchAuthToken', { TransferID, TransferKey })
            resolve(tokenRes)
          }
        } catch (error) {
          reject(error)
        }
       })

    },
    
    setLocale({commit}, data) {
      commit('SET_LOCALE', data)
      localStorage.setItem("locale", data)
    },
    validateXML({commit}, req) {
      return validateXMLApi(req)
    },
    async fetchAuthToken({ commit }, { TransferID, TransferKey }) {
      try {
        let token = await fetchAuthTokenApi(TransferID, TransferKey)
        commit('SET_AUTH_TOKEN', token.token)
        return true
      } catch (error) {
        console.log(error)
        throw error
      }

    },
    loadSession({ commit }, ) {
      let user = localStorage.getItem("user")
      if (user) {
        user = JSON.parse(user)
        commit('SET_USER_DATA', user.userData)
        commit('SET_USER_ADDRESSES', user.userAddresses)
        commit('SET_AUTH_TOKEN', user.authToken)
        commit('SET_USER_CONTRACTS', user.userContracts)
      }
    },

    deleteSession({ commit }) {
      commit('DELETE_SESSION')
    },

  },
  modules: {
  },
  getters: {
    authToken: state => {
      return state.user.authToken
    },
    userData: state => {
      return state.user.userData
    },
    userAddresses: state => {
      return state.user.userAddresses
    },
    isLoggedIn: state => {
      return state.user.userData !== null && state.user.authToken !== null
    },
    suppliers: state => {
      return state.suppliers
    },
    userContracts: state => {
      return state.user.userContracts
    }
  }
})
